import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import contactBg from '../assets/Contact.png';
import { api } from '../utils/api';
import './Contact.css';

const EMPTY = { name: '', email: '', phone: '', company: '', message: '' };

export default function Contact() {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      await api.createInquiry(form);
      setStatus('success');
      setForm(EMPTY);
    } catch {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader
        title="문의하기"
        subtitle="한길에이아이와 함께 시작하세요."
        bgImage={contactBg}
      />
      <section className="page-section">
        <div className="container contact-page">

          {/* 연락처 카드 */}
          <div className="contact-card">
            <div className="contact-card-header">
              <div className="contact-card-icon">💬</div>
              <h2 className="contact-card-title">상담 문의 / 견적서 요청</h2>
              <p className="contact-card-sub">아래 연락처로 문의 주시면 빠르게 안내드리겠습니다.</p>
            </div>
            <div className="contact-card-items">
              <a href="tel:02-6953-7183" className="contact-card-item">
                <span className="contact-card-item-icon">📞</span>
                <div>
                  <div className="contact-card-item-label">전화 문의</div>
                  <div className="contact-card-item-value">02-6953-7183</div>
                </div>
              </a>
              <a href="mailto:info@hangil.ai.kr" className="contact-card-item">
                <span className="contact-card-item-icon">📧</span>
                <div>
                  <div className="contact-card-item-label">이메일 문의</div>
                  <div className="contact-card-item-value">info@hangil.ai.kr</div>
                </div>
              </a>
            </div>
            <p className="contact-card-note">
              견적서 요청 시 사업명, 사업비 규모, 감리 단계를 함께 알려주시면<br />
              보다 정확한 안내가 가능합니다.
            </p>
          </div>

          {/* 온라인 문의 폼 */}
          <div className="contact-card" style={{ marginTop: 32 }}>
            <div className="contact-card-header">
              <div className="contact-card-icon">📝</div>
              <h2 className="contact-card-title">온라인 문의</h2>
              <p className="contact-card-sub">양식을 작성하시면 담당자가 확인 후 연락드립니다.</p>
            </div>

            {status === 'success' && (
              <div className="contact-success">
                문의가 접수되었습니다. 빠른 시일 내에 답변드리겠습니다.
              </div>
            )}
            {status === 'error' && (
              <div className="contact-error">
                전송에 실패했습니다. 잠시 후 다시 시도하거나 이메일로 문의해 주세요.
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label className="contact-form-label">이름 *</label>
                  <input className="contact-form-input" type="text" value={form.name}
                    onChange={set('name')} required placeholder="홍길동" />
                </div>
                <div className="contact-form-group">
                  <label className="contact-form-label">이메일 *</label>
                  <input className="contact-form-input" type="email" value={form.email}
                    onChange={set('email')} required placeholder="example@email.com" />
                </div>
              </div>
              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label className="contact-form-label">전화번호</label>
                  <input className="contact-form-input" type="tel" value={form.phone}
                    onChange={set('phone')} placeholder="02-0000-0000" />
                </div>
                <div className="contact-form-group">
                  <label className="contact-form-label">기관/회사명</label>
                  <input className="contact-form-input" type="text" value={form.company}
                    onChange={set('company')} placeholder="한길에이아이" />
                </div>
              </div>
              <div className="contact-form-group">
                <label className="contact-form-label">문의 내용 *</label>
                <textarea className="contact-form-textarea" value={form.message}
                  onChange={set('message')} required rows={5}
                  placeholder="사업명, 사업비 규모, 감리 단계 등을 작성해 주세요." />
              </div>
              <button type="submit" className="contact-submit-btn" disabled={loading}>
                {loading ? '전송 중...' : '문의 보내기'}
              </button>
            </form>
          </div>

        </div>
      </section>
    </div>
  );
}
